
export function FixNum ( value ) { 
  if( value == undefined || Number(value) == NaN || typeof value == "object" ) return null
  if( Number(value) || Number(value) == 0 ) return Number(value).toFixed(2);
}



// WEBPACK FOOTER //
// ./common/Utils/handleNumUtil.js